import React from 'react';
import { FaEdit } from 'react-icons/fa';
import useCustomNavigate from '../../hooks/useCustomNavigate';

const ProfileCard = ({user}) => {
  const {goTo} = useCustomNavigate()
  console.log("user",user);
  
  if (!user) {
    return <div>Loading...</div>; // Handle case where user data is not available yet
  }

  const { _id,name, mobile, role, rera_id, student_id } = user;

  return (
    <div className='w-full  flex justify-center'>
         <div className="border border-gray-300 rounded-md p-6 flex items-center justify-between w-full max-w-lg h-36 shadow-lg bg-white">
      {/* Left Section: Profile Image */}
      <div className="flex items-center gap-6">
        <img
          src="https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"
          alt="Profile"
          className="h-20 w-20 rounded-full border border-gray-200 object-cover"
        />
        {/* User Information */}
        <div>
        <h2 className="font-semibold text-xl text-gray-800">{name || 'N/A'}</h2>
            <p className="text-sm text-gray-500">Mobile: {mobile || 'N/A'}</p>
            <p className="text-sm text-gray-500">Role: {role || 'N/A'}</p>
            {rera_id && <p className="text-sm text-gray-500">RERA ID: {rera_id}</p>}
            {student_id && <p className="text-sm text-gray-500">Student ID: {student_id}</p>}
        </div>
      </div>

      {/* Right Section: Edit Button */}
      <button 
      className="flex items-center gap-2 px-6 py-3 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700 transition"
      onClick={()=> goTo(`/editprofile/${_id}`)}
      >
        <FaEdit />
        Edit
      </button>
    </div>
    </div>
   
  );
};

export default ProfileCard;
